import { Button, Divider, Modal, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { Api_Url } from '../../config/config';
import axios from 'axios';
import { ErrorToast, SuccessToast, UpdatedToast } from '../../views/ToastComponent';

function CateringBuisnessDetails() {

    const { id } = useParams()
    const [singleData, setSingleData] = useState([])
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);



    const getSingleUser = async () => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/Catering/item/getitemsbycateringid/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setSingleData(response.data.data)
        } catch (error) {
            return error.message
        }
    }

    useEffect(() => {
        getSingleUser()
    }, [])


    const [dairyStoreData, setDairyStoreData] = useState({
        cateringId: id,
        itemName: "",
        quantity: 0,
        pricePerUnit: 0,
        actualCost: 0,
        latitude: "",
        longitude: ""
    })

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {

                const { latitude, longitude } = position.coords;
                setDairyStoreData({ ...dairyStoreData, latitude: latitude.toString(), longitude: longitude.toString() });
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, [])

    const handleSubmit = async () => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/Catering/item`, dairyStoreData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                SuccessToast("Created Successfully")
                handleCancel()
                getSingleUser()
            }
        } catch (error) {
            ErrorToast("something went wrong")
            return error.message
        }
    }

    // Calculations

    const calculateMonthlyRevenue = () => {
        const result = dairyStoreData.quantity * dairyStoreData.pricePerUnit || 0;
        setDairyStoreData(prev => ({
            ...prev,
            actualCost: result
        }))
    };

    React.useEffect(() => {
        calculateMonthlyRevenue();
    }, [dairyStoreData.quantity, dairyStoreData.pricePerUnit]);

    const columns = [
        {
            title: "Name",
            dataIndex: "itemName",
            //   sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
        },
        {
            title: "Quantity",
            dataIndex: "quantity",
            //   sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
        },
        {
            title: "Price",
            dataIndex: "pricePerUnit",
            //   sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
        },
        {
            title: "Actual Cost",
            dataIndex: "actualCost",
            //   sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: 'Edit',
            dataIndex: 'edit',
            sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
            render: (text, record) => (
                <div>
                    {text}
                    <Button
                        type="primary"
                        onClick={() => handleClick(record.id)}
                        style={{ marginLeft: '10px' }}
                    >
                        <i class="fa-solid fa-pen-to-square"></i>
                    </Button>
                </div>
            ),
        },
    ];

    // Update Method

    const handleClick = async (id) => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/Catering/item/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setDairyStoreData(response.data.data)
            setIsEditModalOpen(true)
        } catch (error) {
            return error.message
        }
    }

    // Update 

    const ValueUpdate = async (id) => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/Catering/updateitem/${id}`, dairyStoreData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                UpdatedToast("Successfully Updated")
                handleCancel()
                getSingleUser()
            }
        } catch (error) {
            ErrorToast("Something went wrong")
            return error
        }
    }



    async function handleCancel() {
        setDairyStoreData({
            ...dairyStoreData,
            cateringId: id,
            itemName: "",
            quantity: 0,
            pricePerUnit: 0,
            actualCost: 0,
        })
        setIsEditModalOpen(false)
        setIsModalOpen(false);
    }

    return (
        <>
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="row">
                        <div className="col-12 d-flex align-items-center justify-content-between">
                            <h3 className="mb-0">Catering </h3>
                            <button className="btn btn-primary submit-btn mb-2" onClick={() => setIsModalOpen(true)}>Add Income</button>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-12 mx-auto">
                            <Table
                                className="table-striped"
                                style={{ overflowX: "auto" }}
                                columns={columns}
                                dataSource={singleData}
                                rowKey={(record) => record.id}
                            />
                        </div>
                    </div>

                    <Modal
                        title={<h4>Dairy Assesment</h4>}
                        open={isModalOpen}
                        onOk={() => setIsModalOpen(false)}
                        // closable={false}
                        onCancel={() => handleCancel()}
                        footer={[
                            <div className='d-flex justify-content-between align-items-center'>
                                <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
                                <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={handleSubmit}>Submit</button>
                            </div>
                        ]}
                        width={600}
                        mask={false}
                        maskClosable={false}
                        closeIcon={<span style={{ color: 'red' }}>X</span>}
                    >
                        <div className="modal-body mt-5">
                            <form>
                                <Divider>Dairy Assesment</Divider>

                                <div className="col-sm-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">
                                            Item Name:
                                        </label>
                                        <input className="form-control" type="text" placeholder="Enter item name" value={dairyStoreData.itemName} onChange={(e) => setDairyStoreData({ ...dairyStoreData, itemName: e.target.value })} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="input-block mb-3">
                                            <label className="col-form-label">
                                                Quantity:
                                            </label>
                                            <input className="form-control" type="text" placeholder="Enter item name" value={dairyStoreData.quantity} onChange={(e) => setDairyStoreData({ ...dairyStoreData, quantity: e.target.value })} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="input-block mb-3">
                                            <label className="col-form-label">
                                                Price (per Kg):
                                            </label>
                                            <input className="form-control" type="text" placeholder="Enter item name" value={dairyStoreData.pricePerUnit} onChange={(e) => setDairyStoreData({ ...dairyStoreData, pricePerUnit: e.target.value })} />
                                        </div>
                                    </div>
                                </div>

                                <div className="row my-3">
                                    <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                        <p className="mb-0">Quantity: </p>
                                        <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dairyStoreData.actualCost.toFixed(2)}</span>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </Modal>

                    {/* Edit Modal */}

                    <Modal
                        title={<h4>Update Dairy Assesment</h4>}
                        open={isEditModalOpen}
                        onOk={() => setIsEditModalOpen(false)}
                        // closable={false}
                        onCancel={() => handleCancel()}
                        footer={[
                            <div className='d-flex justify-content-between align-items-center'>
                                <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
                                <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => ValueUpdate(dairyStoreData.id)}>Update</button>
                            </div>
                        ]}
                        width={600}
                        mask={false}
                        maskClosable={false}
                        closeIcon={<span style={{ color: 'red' }}>X</span>}
                    >
                        <div className="modal-body mt-5">
                            <form>
                                <Divider>Dairy Assesment</Divider>

                                <div className="col-sm-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">
                                            Item Name:
                                        </label>
                                        <input className="form-control" type="text" placeholder="Enter item name" value={dairyStoreData.itemName} onChange={(e) => setDairyStoreData({ ...dairyStoreData, itemName: e.target.value })} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="input-block mb-3">
                                            <label className="col-form-label">
                                                Quantity:
                                            </label>
                                            <input className="form-control" type="text" placeholder="Enter item name" value={dairyStoreData.quantity} onChange={(e) => setDairyStoreData({ ...dairyStoreData, quantity: e.target.value })} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="input-block mb-3">
                                            <label className="col-form-label">
                                                Price (per Kg):
                                            </label>
                                            <input className="form-control" type="text" placeholder="Enter item name" value={dairyStoreData.pricePerUnit} onChange={(e) => setDairyStoreData({ ...dairyStoreData, pricePerUnit: e.target.value })} />
                                        </div>
                                    </div>
                                </div>

                                <div className="row my-3">
                                    <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                        <p className="mb-0">Quantity: </p>
                                        <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dairyStoreData.actualCost.toFixed(2)}</span>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </Modal>
                </div>
            </div>
        </>
    )
}

export default CateringBuisnessDetails
